import { CdkMenu, CdkMenuTrigger } from '@angular/cdk/menu';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { LaunchDarklyService } from '../../../../../../core/services/launchdarkly.service';
import { AutoMeasureType } from '../../../../../estimates/estimate-view/plans/auto-measure/entities/auto-measure-types';
import { TakeOffAddOnService } from '../../../../domain/takeoff-addon.service';

@Component({
    selector: 'app-take-off-additional-actions',
    templateUrl: './take-off-additional-actions.component.html',
    imports: [CommonModule, TooltipModule, CdkMenuTrigger, CdkMenu],
    styleUrls: [
        '../../../../../../shared/composable-styles/dropdown-menu.scss',
        '../../../../../../shared/composable-styles/button.scss',
        './take-off-additional-actions.component.scss',
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TakeOffAdditionalActionsComponent {
    isPlanScaled = input<boolean>(false);
    autoMeasureFloor = output<AutoMeasureType>();
    requestAddOn = output();

    readonly #lds = inject(LaunchDarklyService);
    readonly takeOffAddOnService = inject(TakeOffAddOnService);

    isAutoMeasureEnabled = this.#lds.get('takeoffs-ui-uplift') ?? false;

    autoMeasure(type: AutoMeasureType) {
        this.autoMeasureFloor.emit(type);
    }

    needAddOnAbility() {
        this.requestAddOn.emit();
    }
}
